import React, { ReactNode } from 'react';
import { Tooltip } from 'antd';
import { TooltipPlacement } from 'antd/es/tooltip';

type AppTooltipPrpos = {
  title: ReactNode;
  placement: TooltipPlacement;
  arrow?: boolean;
  children: ReactNode;
  color?: string;
};

const AppTooltip: React.FC<AppTooltipPrpos> = ({ title, placement, arrow, children, color }) => {
  return (
    <React.Fragment>
      <Tooltip placement={placement} title={title} arrow={arrow} color={color}>
        {children}
      </Tooltip>
    </React.Fragment>
  );
};

export default AppTooltip;
